(function () {
    "use strict";

    angular
        .module("app")
        .service("cartService", service);

    function service($q, $http) {
        const self = this;
        const maxItemCount = 9999;

        self.items = [];
        self.cartId = 0;
        self.itemCount = 0;
        self.rx_cart_qty = 0;
        self.cs_cart_qty = 0;
        self.itemSubTotal = 0;
        self.itemDiscountSubTotal = 0;
        self.itemBonusDiscountSubTotal = 0;
        self.surchargeSubTotal = 0;
        self.origSubTotal = 0;
        self.subTotal = 0;
        self.paymentTerms = "";
        self.isCartFull = false;
        self.maxItemCount = maxItemCount;
        self.containsScheduleII = false;

        self.shippingMethods = [];
        self.shippingMethod = null;

        self.groundShippingMethodId = null;
        self.secondDayShippingMethodId = null;

        self.total = null;

        self.clear = () => {
            processItems([], true);
        };

        self.refresh = () => {
            return $http
                .get("/api/carts")
                .then(res => processItems(res.data, false))
                .then(self.loadShippingMethods)
                .then(() => {
                    const groundMethod = self.shippingMethods.find(m => m.shipping_method_desc.toLowerCase() === "ground");
                    if (groundMethod)
                        self.groundShippingMethodId = groundMethod.shipping_method_id;
                    else
                        self.groundShippingMethodId = null;

                    const secondDayMethod = self.shippingMethods.find(m => m.shipping_method_desc.toLowerCase() === "2nd day");
                    if (secondDayMethod)
                        self.secondDayShippingMethodId = secondDayMethod.shipping_method_id;
                    else
                        self.secondDayShippingMethodId = null;
                });
        };

        function itemTotal(item) {
            return item.quantity * item.sale_UOM_price;
        }

        function itemDiscountTotal(item) {
            return item.incentives.filter(i => i.incentive_type_Code !== "BDT").reduce((prev, inc) => prev + inc.discount_amount * item.quantity, 0);
        }

        function itemBonusDiscountTotal(item) {
            return item.incentives.filter(i => i.incentive_type_Code === "BDT").reduce((prev, inc) => prev + inc.discount_amount * item.quantity, 0);
        }

        function surchargeTotal(item) {
            const kitCheck = item.kit_check_surcharge == null ? 0 : item.kit_check_surcharge;
            return item.quantity * kitCheck;
        }

        function processItems(items, clearing) {
            self.items = items || [];
            self.itemCount = items.reduce((prev, item) => prev + item.quantity, 0);
            self.itemDiscountSubTotal = self.items.reduce((prev, item) => prev + itemDiscountTotal(item), 0);
            self.itemBonusDiscountSubTotal = self.items.reduce((prev, item) => prev + itemBonusDiscountTotal(item), 0);
            self.itemSubTotal = self.items.reduce((prev, item) => prev + itemTotal(item), 0);
            self.surchargeSubTotal = self.items.reduce((prev, item) => prev + surchargeTotal(item), 0);
            self.origSubTotal = self.itemSubTotal + self.itemDiscountSubTotal + self.itemBonusDiscountSubTotal;
            self.subTotal = self.itemSubTotal + self.surchargeSubTotal;
            if (self.items.length) {
                self.cartId = items[0].cart_id;
                self.paymentTerms = items[0].payment_terms;
            } else {
                self.cartId = 0;
                self.paymentTerms = "";
            }

            self.isCartFull = self.itemCount >= maxItemCount;
            self.containsScheduleII = self.items.some(i => i.schedule_name === "Schedule I" || i.schedule_name === "Schedule II" || i.schedule_name === "Schedule IIN");

            //console.log("cart.items", self.items);

            if (!clearing)
                return $http
                    .get("/api/carts/counts")
                    .then(res => getCartCounts(res.data));
        }

        function getCartCounts(data) {
            self.rx_cart_qty = data.rx_qty;
            self.cs_cart_qty = data.cs_qty;
        }

        self.loadShippingMethods = (zipCode, shippingContactId) => {
            if (self.cartId === 0) {
                self.shippingCost = null;
                self.shippingMethod = null;
                self.shippingMethods = [];
            } else {

                const promises = [
                    self.getShippingMethods(zipCode)
                ];

                if (zipCode && shippingContactId && self.groundShippingMethodId) 
                    promises.push(self.getGroundDays(shippingContactId));

                return $q.all(promises)
                    .then(results => {
                        self.shippingMethods = results[0];
                        let groundDays = -1;
                        if (results.length > 1) {
                            if (results[1].success)
                                groundDays = results[1].groundDays;
                        }

                        let method = null;
                        let defaultMethod = self.shippingMethods.find(m => m.is_default === "Y");
                        if (self.shippingMethod)
                            method = self.shippingMethods.find(m => m.shipping_method_id === self.shippingMethod.shipping_method_id);

                        // default to second day for free if the ground freight is over 2 days  and if the default is ground.
                        if (groundDays > 2 &&
                            self.secondDayShippingMethodId &&
                            defaultMethod.shipping_method_id === self.groundShippingMethodId &&
                            defaultMethod.can_upgrade_to_2ndday) {

                            const originalDefault = angular.copy(defaultMethod);
                            // Un-Default the original default.
                            defaultMethod.is_default = "N";

                            // Make second day the new default and free.
                            defaultMethod = self.shippingMethods.find(m => m.shipping_method_id === self.secondDayShippingMethodId);
                            defaultMethod.is_default = "Y";
                            defaultMethod.is_free_available = originalDefault.is_free_available;
                            defaultMethod.shipping_cost = originalDefault.shipping_cost;
                            defaultMethod.not_free_message = originalDefault.not_free_message;
                        }

                        if (method && defaultMethod) {
                            if (method !== defaultMethod)
                                method = defaultMethod;
                        } else {
                            method = defaultMethod;
                        }
                        self.shippingMethod = method;
                    });

                //let url = `/api/shipping-methods/${self.cartId}`;
                //if (zipCode)
                //    url += `/zip/${zipCode}`;

                //$http
                //    .get(url)
                //    .then(res => self.shippingMethods = res.data)
                //    .then(() => {
                //        const groundMethod = self.shippingMethods.find(m => m.shipping_method_desc.toLowerCase() === "ground");
                //        if(groundMethod)
                //            self.groundShippingMethodId = groundMethod.shipping_method_id;
                //        else 
                //            self.groundShippingMethodId = null;


                //        let method = null;
                //        const defaultMethod = self.shippingMethods.find(m => m.is_default === "Y");
                //        if (self.shippingMethod)
                //            method = self.shippingMethods.find(m => m.shipping_method_id === self.shippingMethod.shipping_method_id);

                //        if (method && defaultMethod) {
                //            if (method !== defaultMethod)
                //                method = defaultMethod;
                //        } else {
                //            method = defaultMethod;
                //        }
                //        self.shippingMethod = method;
                //    });
            }

        }

        self.getShippingMethods = (zipCode) => {
            let url = `/api/shipping-methods/${self.cartId}`;
            if (zipCode)
                url += `/zip/${zipCode}`;
            return $http
                .get(url)
                .then(res => res.data)
        }

        self.getGroundDays = (shippingContactId) => {
            let url = `/api/shipping-methods/ground-days`;
            return $http
                .post(url, {
                    ShippingMethodId: self.groundShippingMethodId,
                    ContactId: shippingContactId,
                    SaturdayShipping: false
                })
                .then(res => {
                    const data = res.data;
                    if (data && data.success)
                        return data.groundDays;
                    else
                        return -1;
                });
        }


        self.calculateShipping = (shippingContactId, saturdayShipping) => {
            const request = {
                WrkOrderId: self.shippingMethod.wrk_order_id,
                ShippingMethodId: self.shippingMethod.shipping_method_id,
                ContactId: shippingContactId,
                SaturdayShipping: saturdayShipping
            };
            return $http.post(`/api/shipping-methods/cost`, request)
                .then(result => result.data)
                .then(data => {
                    if (data.success) {
                        self.shippingMethod.shipping_cost = data.shipping_cost;
                        self.shippingMethod.wrk_order_id = data.wrk_order_id;
                    } else {
                        self.shippingMethod.shipping_cost = null;
                    }
                    return data;
                });
        };

        self.getGroundDays = (shippingContactId, saturdayShipping) => {
            const request = {
                WrkOrderId: self.shippingMethod.wrk_order_id,
                ShippingMethodId: self.shippingMethod.shipping_method_id,
                ContactId: shippingContactId,
                SaturdayShipping: saturdayShipping
            };
            return $http.post(`/api/shipping-methods/ground-days`, request)
                .then(result => result.data)
                .then(data => {
                    if (data.success) {
                        self.shippingMethod.groundDays = data.groundDays;
                    } else {
                        self.shippingMethod.groundDays = null;
                    }
                    return data;
                });
        };

        self.total = () => {
            if (self.shippingMethod && self.shippingMethod.shipping_cost != null)
                return self.subTotal + self.shippingMethod.shipping_cost;
            return null;
        }


        self.addItem = (item) => {
            return self.addItems([item]);
        };

        self.addItems = items => {
            return $q
                .all(items.map(addItem))
                .then(() => {
                    return self
                        .refresh(); // todo: instead of going to the database, could add new item to self.items.  But would need more item data.
                });
        };

        function addItem(item) {

            let quantity = item.quantity;
            if (self.itemCount + quantity > maxItemCount)
                quantity = maxItemCount - self.itemCount;

            const req = {
                item_id: item.item_id,
                quantity,
                quantity_uom_code: item.quantity_uom_code,
                kit_check_surcharge: item.kit_check_surcharge
            };
            return $http.post("/api/carts/add-item", req);
        }

        self.updateItem = (item_id, new_quantity, quantity_uom_code, kit_check_surcharge) => {

            let quantity = new_quantity;
            const existingQuantity = self.items.find(i => i.item_id == item_id && i.sale_UOM == quantity_uom_code).quantity;
            if (quantity > existingQuantity) {
                if (self.itemCount - existingQuantity + quantity > maxItemCount)
                    quantity = maxItemCount - (self.itemCount - existingQuantity);
            }

            const req = {
                item_id,
                new_quantity: quantity,
                quantity_uom_code,
                kit_check_surcharge
            };
            return $http
                .post("/api/carts/update-item", req)
                .then(() => {
                    return self
                        .refresh(); // todo: instead of going to the database, could add new item to self.items.  But would need more item data.
                });
        };

        self.removeItem = (item_id, quantity_uom_code) => {
            const req = {
                item_id,
                quantity_uom_code
            };
            return $http
                .post("/api/carts/remove-item", req)
                .then(() => {
                    return self
                        .refresh(); // todo: instead of going to the database, could add new item to self.items.  But would need more item data.
                });
        };

        self.isOrderFormNumberUnique = (buyerDeaNumber, orderFormNumber) => {
            const req = {
                buyer_DEA_number: buyerDeaNumber,
                order_form_number: orderFormNumber
            };
            return $http
                .post("/api/orders/order-form-number-search", req)
                .then(res => res.data);
        };


        self.createPurchaseOrder = (
            billing_contact_id,
            shipping_contact_id,
            customer_order_no,
            order_name,
            shipping_instructions,
            order_form_number,
            cs_dea_number,
            is_recurring,
            recurring_frequency,
            delivery_contact_phone,
            recur_start_date
        ) => {
            const req = {
                cart_id: self.cartId,
                billing_contact_id,
                shipping_contact_id,
                customer_order_no,
                order_name,
                shipping_instructions,
                shipping_charges: self.shippingMethod.shipping_cost,
                shipping_method_id: self.shippingMethod.shipping_method_id,
                shipping_wrk_order_id: self.shippingMethod.wrk_order_id,
                order_form_number,
                cs_dea_number,
                is_recurring,
                recurring_frequency,
                delivery_contact_phone: delivery_contact_phone,
                recur_start_date
            };

            return $http
                .post("/api/carts/checkout", req)
                .then(res => {
                    return self
                        .refresh()
                        .then(() => res.data.order_id);
                });
        };

        self.createPurchaseOrderCsos = (
            billing_contact_id,
            shipping_contact_id,
            customer_order_no,
            order_name,
            shipping_instructions,
            certificateDeaNumber,
            certificate_id,
            certificatePassword,
            order_form_number,
            delivery_contact_phone
        ) => {
            const req = {
                cart_id: self.cartId,
                billing_contact_id,
                shipping_contact_id,
                customer_order_no,
                order_name,
                shipping_instructions,
                shipping_charges: self.shippingMethod.shipping_cost,
                shipping_method_id: self.shippingMethod.shipping_method_id,
                shipping_wrk_order_id: self.shippingMethod.wrk_order_id,
                certificate_dea_number: certificateDeaNumber,
                certificate_id: certificate_id,
                certificate_password: certificatePassword,
                order_form_number: order_form_number,
                is_recurring: false,
                recurring_frequency: null,
                delivery_contact_phone: delivery_contact_phone,
                recur_start_date: null
            };

            return $http
                .post("/api/carts/checkout-csos", req)
                .then(res => {
                    if (res.data.Success) {
                        return self
                            .refresh()
                            .then(() => res.data);
                    }
                    return res.data;
                });
        };

        self.getPurchaseOrder = orderId => {
            return $http
                .get(`/api/carts/purchase-orders/${orderId}`)
                .then(res => {
                    const po = res.data.detail;
                    po.lines = res.data.lines;
                    po.shipments = res.data.shipments;

                    po.itemCount = po.lines.reduce((prev, item) => prev + item.quantity, 0);

                    po.total = po.order_line_total_amount + po.shipping_charges;

                    return po;
                });
        };
    }

    service.$inject = ["$q", "$http"];

})();